module.exports = __webpack_public_path__ + "assets/img/14a67edd3f221f9ff8ba4e0d196f3b6d.svg";